import React from "react";
import "./aboutSection.css";

const AboutSection = () => {
    return (
        <>

            
            <div className="dmt-about-scope">
                <section id="about" className="about-luxury-section">
                    <div className="container">

                       

                        {/* Stage 1: Left Image & Right Split Content */}
                        <div className="row align-items-start mb-4">

                            {/* Left Side: Sticky Premium Image Frame */}
                            <div className="col-lg-5 d-none  mb-5 mb-lg-0 sticky-lg-top" style={{ top: "30px", zIndex: 1 }}>
                                <div className="about-img-wrapper">
                                    <img
                                        src={require("../../static/img/about-img.png")}
                                        alt="DMT Group Corporate Office"
                                        className="img-fluid custom-rounded-img"
                                    />
                                    <div className="floating-experience-badge">
                                        <h4>11+</h4>
                                        <p>Years of Excellence</p>
                                    </div>
                                </div>
                            </div>

                            {/* Right Side: Initial Executive Blocks */}
                            <div className="col-lg-12">
                                <div className="about-top-stream">

                                    {/* Block 1: Corporate Foundation */}
                                    <div className="corporate-text-block ">
                                        
                                        <p>
                                            <span className="brand-initials">

                                            </span>DMT Group of Companies is a professionally managed Indian business conglomerate established in 2015, with diversified interests across fintech, digital commerce, travel services, media & marketing, accounting solutions, and social welfare initiatives. Founded with a vision to bridge the gap between technology and accessibility, the group has consistently focused on creating innovative, customer-centric, and technology-driven solutions that empower businesses, retailers, entrepreneurs, and individuals across India. Over the years, DMT Group has emerged as a trusted and rapidly growing name in the digital and financial services ecosystem, driven by its commitment to integrity, transparency, operational excellence, and long-term sustainability.
                                        </p>
                                    </div>

                                    {/* Block 2: Philosophy */}
                                    <div className="corporate-text-block ">
                                        {/* <div className="block-indicator">
                                            <span className="dot-pulse text-blue"></span>
                                            <span className="block-title">Core Philosophy</span>
                                        </div> */}
                                        <p>
                                            At the core of DMT Group’s philosophy lies the mission of empowering lives through innovation and inclusive growth. The group strongly believes that technology should not only simplify services but also create opportunities for economic development and social progress. By combining digital innovation with strong business ethics, DMT Group continues to contribute towards India’s vision of financial inclusion, digital transformation, and entrepreneurial empowerment. Its solutions are designed to cater to both urban and rural markets, ensuring accessibility, convenience, and value creation for customers and partners alike.
                                        </p>
                                    </div>

                                    {/* Block 3: Strategic Entities */}
                                    <div className="corporate-text-block unique-accent-block">
                                        {/* <div className="block-indicator">
                                            <span className="dot-pulse highlight-pulse"></span>
                                            <span className="block-title">Operational Entities</span>
                                        </div> */}
                                        <p>
                                            The group operates through its esteemed entities — DMT Empire India Private Limited, Coupon Fares India Private Limited, DMT Media and Marketing Private Limited, and Shardajeet Foundation. Each organization has been strategically established to serve distinct business verticals while collectively contributing towards the group’s broader mission of digital empowerment, innovation, and sustainable growth.
                                        </p>
                                        <p className="">
                                            Through its digital platforms, DMT Group offers a comprehensive range of technology-enabled services aimed at simplifying financial and lifestyle requirements. DMT Kendra serves as the flagship fintech and assisted digital services platform, offering AEPS, Domestic Money Transfer (DMT), recharge services, utility bill payments, PAN card services, micro ATM solutions, and travel booking services. The platform focuses on empowering retailers and channel partners by enabling easy access to essential financial services across India.
                                        </p>
                                    </div>

                                </div>
                            </div>
                        </div>

                        
                        <div className="row ">

                            {/* Block 4: Solutions Portfolio */}
                            <div className="col-md-12 ">
                                <div className="corporate-text-block h-100">
                                    
                                    <p>
                                        Coupon Fares provides affordable travel solutions including flight bookings, hotel reservations, holiday packages, and exclusive travel deals designed to deliver convenience and value-driven experiences. Finwelco is focused on financial inclusion and digital enablement through customer-oriented fintech solutions and services. Additionally, DMT Media and Marketing Private Limited strengthens the group’s capabilities in branding, digital promotions, advertising, and strategic marketing, helping businesses build impactful visibility in an evolving digital landscape.
                                         Beyond business, DMT Group remains deeply committed to social responsibility through Shardajeet Foundation, which actively works towards education, healthcare, women empowerment, community development, and social welfare initiatives.
                                    </p>
                                </div>
                            </div>

                            {/* Block 6: Visionary Footprint (Full Width Banner) */}
                            <div className="col-12 ">
                                <div className="corporate-text-block vision-conclusion-block">
                                    <div className="vision-banner-flex">
                                        {/* <div className="vision-badge">VISION 2026 & BEYOND</div> */}
                                        <p className="m-0">
                                            Driven by innovation, ethical business practices, and a visionary approach since 2015, DMT Group continues to expand its footprint across India by building scalable, future-ready, and impactful solutions. The group remains dedicated to empowering communities, fostering entrepreneurship, strengthening business ecosystems, and contributing meaningfully towards India’s digital and economic growth journey.
                                        </p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            </div>
        </>
    );
};

export default AboutSection;